import React from "react";
import contextProvider from "app/contextProvider";
import {
  Row,
  Col,
  CustomInput,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import Panel from "app/_L1_components/Layout/Panel";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
import Highlighter from "react-highlight-words";

const refType = {
  0: { type: "V", name: "Verbose", number: 1 },
  1: { type: "D", name: "Debug", number: 2 },
  2: { type: "I", name: "Info", number: 3 },
  3: { type: "W", name: "Warn", number: 4 },
  4: { type: "E", name: "Error", number: 5 },
  5: { type: "A", name: "Assert", number: 6 },
};

const refValues = {
  V: 1,
  D: 2,
  I: 3,
  W: 4,
  E: 5,
  A: 6,
};

class Logcat extends _ReactOBaseComponent {
  constructor(props) {
    super(props);
    this._logCat = "";
  }

  state = {
    loading: true,
    opened: false,
    checkedRow: false,
    infoText: "",
    typeFirstTypeName: "Verbose",
    classWrapText: false,
  };

  toggle() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  onComponentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("log")) {
      const logcatURL = decodeURIComponent(urlParams.get("log"));
      fetch(logcatURL)
        .then((response) => response.text())
        .then((text) => this.processData(text));
    } else {
      this.setState({ noLogErr: true });
    }
  }

  processData(text, number) {
    const { search = "", searchLength = "", searchNumber = "" } = this.state;
    let rawTypeList = {};
    let _checkedRow = false;
    let infoColorClass = null;
    let matchCounter = 0;

    let _number = number || searchNumber;
    let formatted = text
      .split("\n")
      .map((line) => {
        let cols = line.split(" ").filter((item) => item !== "");
        if (cols.length >= 5) {
          rawTypeList[cols[4]] = "_";
          return {
            line: line,
            type: cols[4],
            number: refValues[cols[4]],
          };
        }
        return { line: line, number: 1 };
      })
      .filter((row) => {
        return !_number || row.number >= _number;
      })
      .filter((row) => {
        if (search && search[0].test(row.line)) {
          if (searchLength > 0) {
            _checkedRow = true;
            infoColorClass = "";
            matchCounter += row.line.match(search[0]).length;
          }
          return search[0].test(row.line);
        } else return !search;
      });

    let typeList = Object.values(refType).filter((ref) => {
      return rawTypeList[ref.type];
    });

    if (this.state.regexError == true) {
      infoColorClass = "text-danger";
    }

    if (formatted.length == 0) {
      _checkedRow = false;
      this.setState({
        infoText: "No matches",
        infoColorClass: null,
      });
    }

    // this.typeFirstTypeName = Object.values(this.typeList[0].name).join("");
    this.setState({
      logCat: text,
      loading: false,
      formatted: formatted,
      matchCounter: matchCounter,
      checkedRow: _checkedRow,
      typeList: typeList,
      infoColorClass: infoColorClass,
    });
  }

  delay(time, string) {
    if (time == this.globalTime) {
      // && this.manualSearch == false per manual fire

      try {
        var regex = [new RegExp(string, "ig")];
        if (string.length == 0) {
          this.setState({
            checkedRow: false,
            infoText: "",
            search: regex,
            regexError: false,
            searchLength: string.length,
          });
        } else {
          this.setState({
            search: regex,
            searchLength: string.length,
            regexError: false,
          });
        }
        this.processData(this.state.logCat);
      } catch (e) {
        this.setState({
          // search: new RegExp(""),
          checkedRow: false,
          regexError: true,
          infoText: "Pattern error",
          infoColorClass: "text-danger",
          // searchLength: string.length,
        });
        // this.processData();
        return false;
      }
    }
  }

  onRender() {
    return (
      <_LoadingWrapper minHeight loadingPlug={this.state.loading}>
        {this.state.formatted && this.state.noLogErr == undefined ? (
          <div className="wrapper_log bg-light">
            <div className="px-3 pt-3 pb-2 border-bottom border-3 border-primary header-logcat">
              <Row>
                <Col>
                  <h5>Logcat viewer</h5>
                </Col>
                <Col className="d-flex justify-content-end mr-3">
                  <CustomInput
                    type="switch"
                    className="mt-1 label-logcat-wrap"
                    size="sm"
                    id="exampleCustomCheckbox2"
                    // label="Wrap text"
                    onClick={() => {
                      this.setState({ classWrapText: !this.state.classWrapText });
                    }}
                  />
                  <label className="my-auto pt-1 label-logcat-wrap">
                    <span>WRAP TEXT</span>
                  </label>
                </Col>

                <Col className="d-flex justify-content-end mt-3 mt-lg-0">
                  <Dropdown
                    isOpen={this.state.opened}
                    toggle={this.toggle.bind(this)}
                    direction="down"
                    className="mr-4 pr-4"
                    size="sm"
                  >
                    <DropdownToggle className="btn btn-white button-select-logcat">
                      <div className="d-flex">
                        <div className="flex-grow-1 text-truncate">
                          <span> {this.state.typeFirstTypeName}</span>
                        </div>
                        <div>
                          <span className="caret icon-caret-down"></span>
                        </div>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      {this.state.typeList.map((val, id) => {
                        return (
                          <DropdownItem
                            onClick={() => {
                              this.setState({
                                typeFirstTypeName: val.name,
                                searchNumber: val.number,
                              });
                              this.processData(this.state.logCat, val.number);
                            }}
                            key={id}
                            active={this.state.typeFirstTypeName == val.name}
                          >
                            <span>{val.name}</span>
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </Dropdown>
                  <input
                    className="form-input-text form-control-sm form-control"
                    type="text"
                    // size="sm"
                    placeholder="Regex..."
                    onChange={(e) => {
                      this.globalTime = Date.now();
                      let singleTime = Date.now();
                      let string = e.target.value;
                      setTimeout(() => {
                        this.delay(singleTime, string);
                      }, 1200);
                    }}
                  />{" "}
                  <span
                    className={
                      this.state.infoColorClass != null
                        ? "sub-title my-auto text-right " + this.state.infoColorClass
                        : "sub-title my-auto text-right"
                    }
                    style={
                      this.getAppContext().media.isDesktopXl
                        ? { width: "285px" }
                        : { width: "240px" }
                    }
                  >
                    <strong>
                      {" "}
                      {this.state.checkedRow == true
                        ? this.state.matchCounter + " matches"
                        : this.state.infoText}
                    </strong>
                  </span>
                </Col>
              </Row>
            </div>
            <div
              id="container-logcat"
              className={`horizontal-scroll bg-dark text-light ${
                // bg-dark text-light
                this.state.classWrapText ? "text-log-wrap" : "text-log-no-wrap"
              } pt-2`}
              style={{
                height: `${window.innerHeight - 74}px`,
              }}
            >
              {this.state.formatted.map((row, id) => {
                return (
                  <div className="item" key={id}>
                    {" "}
                    <Highlighter
                      highlightClassName="background-highlight"
                      searchWords={this.state.search ? this.state.search : []}
                      autoEscape={false}
                      textToHighlight={row.line}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ) : this.state.noLogErr == true ? (
          <Panel className="mx-4 my-4" bodyClassName="p-0" rounded>
            <div className="py-4 ml-2"> No logcat available</div>
          </Panel>
        ) : null}
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(Logcat, {
  define: null,
});
